module.exports = __webpack_public_path__ + "img/hadamard.29dac7ee.svg";